<template>
    <portal to="modals">
        <div class=" modal-backdrop z-20 w-full scrolling-touch" @click.self="outsideClose">
            <div class="modal w-95% lg:w-full xl:w-full overflow-hidden" :style="[partners ? '' : {'max-width' : `${max_width}px`}, {'min-width' : `${minWidthPx}px`}]" :class="{'wide' : wide, 'partners' : partners}">
                <div class="flex flex-col w-full relative bg-white">

                    <div class=" h-10 relative flex items-center justify-center flex-col  z-50" :class="{'mt-4':ratingInfo}">
                        <img src="@/assets/SVG/cross-partners.svg" class="absolute text-white pin-t pin-r mr-4 mt-4 cursor-pointer text-xl z-50 h-4" @click="$emit('close')">
                    </div>

                    <div class="bg-white relative" :class="{'pt-16 -mt-16' : !wide, 'pt-24 -mt-24': wide, 'long' : long, 'overflow-y-scroll h-80vh': isPhone === 'mobile' && isRegistration, 'overflow-y-scroll max-h-80vh': isPhone === 'desktop' && isRegistrationDesktop}">
                        <slot></slot>
                    </div>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>

    </portal>
</template>

<script>
import isMobile from '@/mixins/isMobile.js';

export default {
  name: 'modal',
  mixins: [isMobile],
  props: {
    wide: {
      type: Boolean,
      default: false,
    },
    click_outside: {
      type: Boolean,
      default: true,
    },
    isRegistration: {
      type: Boolean,
      default: false,
    },
    isRegistrationDesktop: {
      type: Boolean,
      default: false,
    },
    max_width: {
      type: Number,
      default: 360,
    },
    partners: {
      type: Boolean,
      default: false,
    },
    long: {
      type: Boolean,
      default: false,
    },
    minWidthPx: {
      type: String,
      default: '',
    },
    ratingInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPhone() {
      return this.isMobile;
    },
  },
  methods: {
    outsideClose() {
      if (this.click_outside === true) this.$emit('close');
    },
  },
};
</script>

<style scoped>

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 2rem;
        background-color: rgba(0, 0, 0, 0.5);

    }

    .modal {
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        /*width: 100%;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal.wide {
        max-width: 655px;
        width: 100%;

    }

    .modal.partners {
        max-width: 505px;
        width: 100%;

    }

    .modal {
        border-radius: 0.85rem;
        -webkit-box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
        box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
    }

    .long {
        padding-top: 20px !important;
        @apply rounded-lg;
        margin-top: 700px  !important;
        margin-bottom: 70px !important;
    }

    @media only screen and (min-width: 319px) and (max-width: 330px) {
        .iphone-head-height {
            height: 5.6rem !important;
        }
    }
    ::-webkit-scrollbar {
        display: none;
    }
</style>
